import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
const PrivateRoute = ({ element, requiredRole }) => {
  const storeData = useSelector((state) => state.mainReducer);
  const { userData } = storeData;
  // const { isAuthenticated, user } = useAuth();
  // if (!isAuthenticated) {
  //   return <Navigate to="/login" />;
  // }

  if (!userData) {
    return <Navigate to="/login" replace />;
  }

  if (Array.isArray(requiredRole)) {
    if (!requiredRole.includes(userData?.role || "")) {
      return <Navigate to="/not-found" />;
    }
  } else if (typeof requiredRole === "string") {
    if (userData.role !== requiredRole) {
      return <Navigate to="/not-found" />;
    }
  }
  return element;
};

export default PrivateRoute;
